import { gsap, ScrollTrigger } from "../LibrariesImport";

export default class SouAnimations {
    constructor() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.initHeroEntrance();
        this.initHeroImageReveal();
        this.initHeroParallax();
        this.initScrollAppear();
        this.initFooterWatermark();
    }

    // ── Hero : apparition séquencée au chargement ────────────────────
    initHeroEntrance() {
        const lines       = document.querySelectorAll('.sou-hero-title-line');
        const description = document.querySelector('.sou-hero-description');

        if (!lines.length) return;

        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        tl.from(lines, {
            opacity: 0,
            y: 48,
            duration: 0.75,
            stagger: 0.12,
        }, 0);

        if (description) {
            tl.from(description, { opacity: 0, y: 20, duration: 0.6 }, '-=0.3');
        }

        // Trait crayon rose qui se dessine sous la ligne 2 du titre
        const line2 = document.querySelector('.sou-hero-title-line-2');
        if (line2) {
            gsap.set(line2, { '--hero-underline': '0%' });
            tl.to(line2, {
                '--hero-underline': '100%',
                duration: 0.5,
                ease: 'power2.out',
            }, '-=0.25');
        }
    }

    // ── Hero : le polaroïd se pose, puis les gommettes se collent ────
    initHeroImageReveal() {
        const media = document.querySelector('.sou-hero-media');
        if (!media) return;

        const image   = media.querySelector('.sou-hero-photo img');
        const doodles = media.querySelectorAll('.sou-hero-doodle');

        const tl = gsap.timeline({ delay: 0.3 });

        // Sur la colonne (et non le cadre, dont le scale est piloté par la parallaxe)
        tl.from(media, {
            opacity: 0,
            y: 30,
            rotate: -4,
            duration: 1.2,
            ease: 'expo.out',
        }, 0);

        if (image) {
            tl.fromTo(image, { scale: 1.2 }, { scale: 1.05, duration: 1.8, ease: 'expo.out' }, 0);
        }

        if (doodles.length) {
            tl.from(doodles, { scale: 0, duration: 0.5, stagger: 0.12, ease: 'back.out(2.5)' }, 0.8);
        }
    }

    // ── Hero : parallaxe zoomée (cadre + image scale up) ─────────────
    initHeroParallax() {
        const hero      = document.querySelector('.sou-hero');
        const heroFrame = document.querySelector('.sou-hero-image-frame');
        const heroImage = document.querySelector('.sou-hero-image-frame img');

        if (!hero || !heroFrame || !heroImage) return;

        const st = {
            trigger: hero,
            start: 'top top',
            end: 'bottom top',
            scrub: 1,
        };

        // Le cadre scale up au scroll
        gsap.to(heroFrame, {
            scale: 1.06,
            ease: 'none',
            scrollTrigger: st,
        });

        // Filigrane "1906" glisse vers la gauche au scroll
        const watermark = document.querySelector('.sou-hero-watermark');
        if (watermark) {
            gsap.to(watermark, {
                xPercent: -18,
                ease: 'none',
                scrollTrigger: { ...st, scrub: 2 },
            });
        }
    }

    // ── Apparitions au scroll ─────────────────────────────────────────
    initScrollAppear() {
        // Cartes événements — apparition en stagger par liste
        document.querySelectorAll('.events-list, .events-past-list').forEach(list => {
            const cards = list.querySelectorAll('.event-card');
            if (!cards.length) return;

            gsap.from(cards, {
                opacity: 0,
                y: 8,
                duration: 0.9,
                stagger: 0.07,
                ease: 'power2.out',
                clearProps: 'transform', // sinon le transform inline écrase le tilt CSS au :hover
                scrollTrigger: {
                    trigger: list,
                    start: 'top 95%',
                }
            });
        });

        // Éléments numérotés — stagger
        document.querySelectorAll('.numbered-items-grid').forEach(grid => {
            const items = grid.querySelectorAll('.numbered-item');
            if (!items.length) return;

            gsap.from(items, {
                opacity: 0,
                y: 8,
                duration: 0.9,
                stagger: 0.07,
                ease: 'power2.out',
                clearProps: 'transform', // sinon le transform inline bloque le soulèvement au :hover
                scrollTrigger: {
                    trigger: grid,
                    start: 'top 95%',
                }
            });
        });

        // Galeries d'images (grille + masonry) — stagger léger.
        // On anime .img (et non la colonne) : la colonne est positionnée par Masonry
        // en transform, l'animer entrerait en conflit avec la mise en page.
        document.querySelectorAll('.block-image-grid .row').forEach(grid => {
            const imgs = grid.querySelectorAll('.img');
            if (!imgs.length) return;

            gsap.from(imgs, {
                opacity: 0,
                y: 8,
                duration: 0.9,
                stagger: 0.07,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: grid,
                    start: 'top 95%',
                }
            });
        });

        // Titres de blocs
        document.querySelectorAll([
            '.block-events-list-heading',
            '.block-numbered-items-surtitre',
            '.block-numbered-items-intro',
        ].join(',')).forEach(el => {
            gsap.from(el, {
                opacity: 0,
                y: 8,
                duration: 0.9,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: el,
                    start: 'top 95%',
                }
            });
        });
    }

    // ── Footer : filigrane "Lancié" translate au scroll ──────────────
    initFooterWatermark() {
        const watermark = document.querySelector('.sou-footer-watermark');
        if (!watermark) return;

        gsap.fromTo(watermark,
            { x: '18%' },
            {
                x: '0%',
                ease: 'none',
                scrollTrigger: {
                    trigger: watermark.closest('footer'),
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: 1.5,
                }
            }
        );
    }
}
